import AppConstants from '../constants/AppConstants';
import { AxiosGoogleSheetsClient } from '../proxy/ProxyClients';

const GoogleSheetsService = {
  allGoogleSheetHtmlTemplates: (email: string, token: string) => AxiosGoogleSheetsClient.allGoogleSheetHtmlTemplates(),
  downloadGoogleSheetHtmlTemplate: (googleSheetHtmlTemplateId: number | undefined, googlesheetId: number | undefined) => AxiosGoogleSheetsClient.downloadGoogleSheetHtmlTemplate(
    googleSheetHtmlTemplateId,
    googlesheetId
  )
};

export default GoogleSheetsService;
